import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

import Icon from '../../../../../assets/images/pro/pay_with_paypal@2x.png';

import styles from '../styles/styles.module.scss';

const PayWithPayPalButton = ({ text, handler }) => {
  const content = (
    <span className={styles.contents}>
      {text}
      <img className={styles.payPalIcon} src={Icon} />
    </span>
  );

  return <SubmitButton text={content} handler={handler} variant="payPalCheckout" />;
};

PayWithPayPalButton.defaultProps = {
  text: 'Checkout with PayPal',
  handler: () => {}
};

PayWithPayPalButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default PayWithPayPalButton;
